import { SelectIF } from '@/types/common';

export type GenderT = 'Male' | 'Female';
export type GenderClothingT = GenderT | 'Unisex';

export const GENDERS_PROPERTIES: SelectIF<GenderT>[] = [
    {
        value: 'Male',
        label: 'Мужской',
    },
    {
        value: 'Female',
        label: 'Женский',
    },
];
